import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes/index';
import './i18n';
import './index.css';
import 'semantic-ui-css/semantic.min.css';

ReactDOM.render(<Routes />, document.getElementById('root'));
